import React from "react";
import { Link } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";

type TwoColumnListType = {
    title: string,
    subTitle: string,
    titleUrl: string,
    buttonTitle: string,
    buttonUrl: string,
    className?: string,
    location : string
}

const TwoColumList = (props: TwoColumnListType) => {
    const { title, subTitle, titleUrl, buttonTitle, buttonUrl, className, location } = props;

    const user = useAuth().getUser();
    const ssoToken = user ? user.ssoToken : null;

    const sameDomainRegex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]raps+)\.org(\?.*)?(\/.*)?$/;
    const sameDomainWithQueryRegex = /^(?:(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]raps+)\.org)(\/?(\?.+))$/;
    const isSameDomain = buttonUrl.match(sameDomainRegex)
    const formattedButtonUrl = ssoToken && isSameDomain ? buttonUrl.match(sameDomainWithQueryRegex) ? buttonUrl + "&sso=" + ssoToken : buttonUrl + "?sso=" + ssoToken : buttonUrl;

    return (
    <div className={className ?? "event-item box-shadow-off register-item col-md-12"} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
        <div className="row">
            <div className="col-xl-10 col-lg-9 ">
                <div className="event-left-section">
                    <h4>
                        <Link to={`events/${titleUrl}`}>{title}</Link>
                    </h4>
                        <p>{subTitle} <span>{ location }</span></p>
                </div>
            </div>
            <div className="col-xl-2 col-lg-3" style={{background: "#FBC46C"}}>
                <div className="event-right-section">
                    <span className="eventleft">
                        <a href={formattedButtonUrl} target={isSameDomain ? undefined : "_blank"}>{buttonTitle}</a>
                    </span>
                </div>
            </div>
        </div>
        <div className="clear"></div>
    </div>)
}

export default TwoColumList;

function onMouseOver(element: React.MouseEvent<HTMLDivElement>){
    const div: HTMLDivElement = element.currentTarget;
    div.style.border = "#FBC46C 1px solid";
}

function onMouseOut(element: React.MouseEvent<HTMLDivElement>){
    const div: HTMLDivElement = element.currentTarget;
    div.style.border = "#FFF 1px solid"
}